
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("igBnm", function(module, exports) {
/**
 * @generated SignedSource<<6d497f63098010f2b4eb5bd237ed3dff>>
 * @relayHash c5d2ac4a1537d7803281195f96d80c46
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8e3b72497ed539c6ef0e7585f8487e809a8f4bf421d724bf0347df59de7511f4
const $66fb75d742ae697c$var$node = function() {
    var v0 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "homePagesDisplayView"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useHomeViewsUserPreferencesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useHomeViewsUserPreferencesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "c5d2ac4a1537d7803281195f96d80c46",
            "id": "8e3b72497ed539c6ef0e7585f8487e809a8f4bf421d724bf0347df59de7511f4",
            "metadata": {},
            "name": "useHomeViewsUserPreferencesQuery",
            "operationKind": "query",
            "text": "query useHomeViewsUserPreferencesQuery{userPreferences{homePagesDisplayView}}"
        }
    };
}();
$66fb75d742ae697c$var$node.hash = "a460b0b4084b80e4445d972d6b5860d1";
var $66fb75d742ae697c$export$2e2bcd8739ae039 = $66fb75d742ae697c$var$node;
module.exports["default"] = $66fb75d742ae697c$export$2e2bcd8739ae039;

});

parcelRegister("dDu9z", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $dinVW = parcelRequire("dinVW");


var $9DHhW = parcelRequire("9DHhW");


var $71GjD = parcelRequire("71GjD");


var $5BwjK = parcelRequire("5BwjK");

var $qaY7H = parcelRequire("qaY7H");

var $aoeyL = parcelRequire("aoeyL");

var $gETnG = parcelRequire("gETnG");

var $c9Olr = parcelRequire("c9Olr");

var $dDr80 = parcelRequire("dDr80");

var $9CEYG = parcelRequire("9CEYG");

var $1R1bQ = parcelRequire("1R1bQ");

var $fROKr = parcelRequire("fROKr");

var $eSkJX = parcelRequire("eSkJX");

var $63k9q = parcelRequire("63k9q");

const $f2ffb31ca33bfa58$var$styles = {
    container: "_39xV02Hakr",
    header: "_39xV02N91d _4ouGXIdnbC",
    headerIcon: "_3iDTPbQ4SZ _37wbyuI7V3 _3YEZNOdnbC",
    titleContainer: "_4ouGXIdnbC _1EqgXlN91d"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f2ffb31ca33bfa58$var$FooterContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNOdnbC _1bHrqEIZbP _3iDTPbQ4SZ _0hPCNLz9WS",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f2ffb31ca33bfa58$var$Footer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_39xV02N91d _3138425zaO _3iDTPbQ4SZ _37wbyuI7V3 _0hPCNLDIqT",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f2ffb31ca33bfa58$var$CardFooter = (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { isEndOfPage: isEndOfPage } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c9Olr.LastAction), null);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1R1bQ.SocialProof), null);
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== isEndOfPage) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f2ffb31ca33bfa58$var$FooterContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f2ffb31ca33bfa58$var$Footer, null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.100"
        }, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5BwjK.AudioPlaylistButton), {
            isEndOfPage: isEndOfPage
        }))));
        $[2] = isEndOfPage;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
};
const $f2ffb31ca33bfa58$export$52243c6737c37941 = (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { shouldUseAutomationDiscovery: shouldUseAutomationDiscovery, isEndOfPage: isEndOfPage, onCardClick: onCardClick } = t0;
    const t1 = isEndOfPage ? (0, $71GjD.FeatureCode).EOP_REC_CARD : (0, $71GjD.FeatureCode).PAGE_TREE_CARD;
    let t2;
    if ($[0] !== onCardClick || $[1] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9CEYG.PageLink), {
            shouldHideFolder: true,
            featureAttributionCode: t1,
            onCardClick: onCardClick
        });
        $[0] = onCardClick;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f2ffb31ca33bfa58$var$styles.headerIcon,
            as: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aoeyL.ContentIcon), null));
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            alignBlock: "start",
            alignInline: "start",
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            alignInline: "start",
            shouldWrap: false,
            grow: "fill",
            space: "space.100"
        }, t3, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $f2ffb31ca33bfa58$var$styles.header,
            alignBlock: "start",
            alignInline: "start",
            grow: "fill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f2ffb31ca33bfa58$var$styles.titleContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $63k9q.Title), {
            singleLine: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eSkJX.Subtitle), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fROKr.StatusLozenge), null)));
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gETnG.Excerpt), null);
        $[4] = t4;
        $[5] = t5;
    } else {
        t4 = $[4];
        t5 = $[5];
    }
    let t6;
    if ($[6] !== isEndOfPage) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            padding: "space.200",
            xcss: $f2ffb31ca33bfa58$var$styles.container,
            testId: "page-card-popup-view"
        }, t4, t5, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f2ffb31ca33bfa58$var$CardFooter, {
            isEndOfPage: isEndOfPage
        }));
        $[6] = isEndOfPage;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== shouldUseAutomationDiscovery) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $qaY7H.AutomationDiscoveryMessage), {
            shouldUseAutomationDiscovery: shouldUseAutomationDiscovery
        });
        $[8] = shouldUseAutomationDiscovery;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== isEndOfPage || $[11] !== t2 || $[12] !== t6 || $[13] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f2ffb31ca33bfa58$var$PopupViewBase, {
            isEndOfPage: isEndOfPage
        }, t2, t6, t7);
        $[10] = isEndOfPage;
        $[11] = t2;
        $[12] = t6;
        $[13] = t7;
        $[14] = t8;
    } else t8 = $[14];
    return t8;
};
const $f2ffb31ca33bfa58$var$PopupViewBase = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, isEndOfPage: isEndOfPage } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== isEndOfPage) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "confluence",
                    action: "clicked",
                    actionSubject: isEndOfPage ? "relatedContentCard" : "spacePageCard",
                    actionSubjectId: "excerptPopup",
                    attributes: {
                        source: isEndOfPage ? "endOfPageRecommendations" : "pageTree"
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = isEndOfPage;
        $[2] = t1;
    } else t1 = $[2];
    const handlePopupClick = t1;
    let t2;
    if ($[3] !== children || $[4] !== handlePopupClick) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dDr80.PageCardContainer), {
            isHoverPageCard: true,
            onClick: handlePopupClick
        }, children);
        $[3] = children;
        $[4] = handlePopupClick;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};
module.exports["PopupView"] = $f2ffb31ca33bfa58$export$52243c6737c37941;

});

parcelRegister("2mfTa", function(module, exports) {

var $cxMI6 = parcelRequire("cxMI6");


var $ctLrB = parcelRequire("ctLrB");

const $cfb387504b3ebb46$var$getLastActionFromRecent = (recent, isActivityV3HomeRecent)=>{
    const timestamp = isActivityV3HomeRecent ? recent.event?.timestamp || '' : recent.timestamp || '';
    const recentAction = isActivityV3HomeRecent ? recent.event?.eventType : recent.object?.events?.[0].eventType;
    let action;
    switch(recentAction){
        case (0, $ctLrB.ActivityEventType).COMMENTED:
            action = 'commented';
            break;
        case (0, $ctLrB.ActivityEventType).EDITED:
        case (0, $ctLrB.ActivityEventType).UPDATED:
        case (0, $ctLrB.ActivityEventType).PUBLISHED:
        case (0, $ctLrB.ActivityEventType).SNAPSHOTTED:
            action = 'edited';
            break;
        case (0, $ctLrB.ActivityEventType).CREATED:
        case (0, $ctLrB.ActivityEventType).STARTED:
            action = 'createdByYou';
            break;
        case (0, $ctLrB.ActivityEventType).VIEWED:
            action = 'visited';
            break;
        case (0, $ctLrB.ActivityEventType).LIKED:
            action = 'liked';
            break;
    }
    return {
        when: timestamp,
        action: action
    };
};
const $cfb387504b3ebb46$export$b3035d9add269629 = (recent, untitledDraftText = '', isWhiteboardEmojiFGEnabled = false, isActivityV3HomeRecent = false)=>{
    const content = isActivityV3HomeRecent ? recent.object?.data : recent.object?.content;
    return {
        ...(0, $cxMI6.transformGlobalContent)(content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent),
        // Using ConfluencePage to fix type error caused by ConfluenceFooterComment not having id in the types file
        key: isActivityV3HomeRecent ? `${content?.id}-${recent?.event?.eventType}` : `${content?.id}-${recent.object?.events?.[0].eventType}`,
        lastAction: $cfb387504b3ebb46$var$getLastActionFromRecent(recent, isActivityV3HomeRecent)
    };
};
const $cfb387504b3ebb46$export$9630855043012801 = (created, untitledDraftText = '', userId = null)=>{
    const id = created?.content?.id || '';
    const content = created?.content;
    const isContentCreatedByCurrentUser = (0, $ctLrB.isCreatorCurrentUser)(userId, content);
    const actionText = !isContentCreatedByCurrentUser ? 'ownedByYou' : 'createdByYou';
    return {
        ...(0, $cxMI6.transformGlobalContent)(content, untitledDraftText),
        key: `${id}-created`,
        lastAction: {
            when: created.content?.metadata.createdDate || '',
            action: actionText
        }
    };
};
const $cfb387504b3ebb46$export$9e542ec8039a0bcd = (draft, untitledDraftText = '')=>{
    const content = draft?.content;
    const id = content?.id || '';
    return {
        ...(0, $cxMI6.transformGlobalContent)(content, untitledDraftText),
        key: `${id}-draft`,
        lastAction: {
            when: content?.metadata.lastModifiedDate || '',
            action: 'edited'
        }
    };
};
const $cfb387504b3ebb46$export$7d474971357ff1a1 = (data, untitledDraftText = '')=>{
    return {
        ...(0, $cxMI6.transformGlobalContent)(data, untitledDraftText),
        lastAction: {
            when: data?.metadata.currentuser?.viewed?.lastSeen || data?.history?.lastUpdated?.when || '',
            action: data?.metadata.currentuser?.viewed?.lastSeen ? 'visited' : 'updated'
        }
    };
};
module.exports["transformRecentToPageCard"] = $cfb387504b3ebb46$export$b3035d9add269629;
module.exports["transformCreatedByMeToPageCard"] = $cfb387504b3ebb46$export$9630855043012801;
module.exports["transformDraftToPageCard"] = $cfb387504b3ebb46$export$9e542ec8039a0bcd;
module.exports["transformStarredToPageCard"] = $cfb387504b3ebb46$export$7d474971357ff1a1;

});

parcelRegister("288YL", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $eKMV3 = parcelRequire("eKMV3");


var $dkIiA = parcelRequire("dkIiA");


var $bZSO8 = parcelRequire("bZSO8");

const $c299cfa438844b48$var$i18n = (0, $kSwu1.defineMessages)({
    createPage: {
        id: "home.home-views.create-page",
        defaultMessage: "Create a page"
    },
    createLivePage: {
        id: "home.home-views.create-live-doc",
        defaultMessage: "Create a live doc"
    },
    createDoc: {
        id: "home.home-views.create-doc",
        defaultMessage: "Create doc"
    }
});
const $c299cfa438844b48$export$305e51f590235bd4 = ({ appearance: appearance, creationLinkSource: creationLinkSource, showCreateDocButton: showCreateDocButton, showCreateLivePageButton: showCreateLivePageButton })=>{
    const creationHref = (0, $bZSO8.buildCreationLink)({
        contentType: 'page',
        source: creationLinkSource,
        withFallback: true,
        subType: (0, $dkIiA.ConfluencePageSubType).LIVE
    });
    let message = $c299cfa438844b48$var$i18n.createPage;
    if (showCreateDocButton) message = $c299cfa438844b48$var$i18n.createDoc;
    else if (showCreateLivePageButton) message = $c299cfa438844b48$var$i18n.createLivePage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
        href: creationHref,
        appearance: appearance,
        shouldFitContainer: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), message));
};
module.exports["CreatePageButton"] = $c299cfa438844b48$export$305e51f590235bd4;

});

parcelRegister("3acIx", function(module, exports) {
/* PageCards.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $55fM8 = parcelRequire("55fM8");


var $1LXnB = parcelRequire("1LXnB");


var $bDgLe = parcelRequire("bDgLe");














var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $dDr80 = parcelRequire("dDr80");

var $aoeyL = parcelRequire("aoeyL");

var $c9Olr = parcelRequire("c9Olr");

var $9CEYG = parcelRequire("9CEYG");










var $bQm3c = parcelRequire("bQm3c");


var $1ggpj = parcelRequire("1ggpj");

const $660080b0a61a732e$export$75ba55e1c62d2f65 = (contentType)=>{
    return (0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database';
};



var $2cKGu = parcelRequire("2cKGu");


var $AXitC = parcelRequire("AXitC");








var $kSwu1 = parcelRequire("kSwu1");


var $gC2EJ = parcelRequire("gC2EJ");


var $lpNn5 = parcelRequire("lpNn5");


var $de2j9 = parcelRequire("de2j9");


var $sD2Tz = parcelRequire("sD2Tz");


var $jlIaF = parcelRequire("jlIaF");


var $56QzY = parcelRequire("56QzY");


var $39rFu = parcelRequire("39rFu");


var $7NoF3 = parcelRequire("7NoF3");














var $7ZB0A = parcelRequire("7ZB0A");

const $9435f53888e733e2$export$3c1d9e6f68d6384d = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $7ZB0A.default) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0sElkwUofl",
            __cmplp.isSelected ? "_4vhRtvcfNK" : "_4vhRtv1PzL",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});



var $jsaQN = parcelRequire("jsaQN");











// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $146c0ee07cc94a7d$var$HiddenAction = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_23rrnHbv7O _1YKVNsqGUA",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $146c0ee07cc94a7d$var$StaticAction = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_42Yu6B7dHp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $146c0ee07cc94a7d$export$37ab3bdebc286ca = (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    const { hidden: hidden } = (0, $cozmU.useContext)((0, $7f1b580bd70ac23d$export$e53fea40f770c4e5));
    const Container = hidden ? $146c0ee07cc94a7d$var$HiddenAction : $146c0ee07cc94a7d$var$StaticAction;
    let t1;
    if ($[0] !== Container || $[1] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Container, null, children);
        $[0] = Container;
        $[1] = children;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};


const $cea5a5dbb111468f$var$i18n = (0, $kSwu1.defineMessages)({
    edit: {
        id: "page-card.quick-actions.edit.page",
        defaultMessage: "Edit"
    },
    editLabel: {
        id: "page-card.quick-actions.edit.aria-label",
        defaultMessage: "Edit {title}"
    }
});
const $cea5a5dbb111468f$export$a8d3280cb45e38b8 = ()=>{
    const $ = (0, $bDgLe.c)(31);
    const { id: id, space: space, type: type, links: t0, appearance: appearance, title: title, editorVersion: editorVersion } = (0, $cozmU.useContext)((0, $AXitC.PageCardContext));
    const { editui: editui } = t0;
    const { loadEditor: loadEditor } = (0, $39rFu.useEditPageLoadingActions)();
    const intl = (0, $kSwu1.useIntl)();
    const spaceKey = space?.spaceKey;
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const compact = appearance === "compact-list";
    let t1;
    if ($[0] !== editorVersion?.nodes?.[0]?.value) {
        t1 = editorVersion?.nodes?.[0]?.value?.replace(/['"]+/g, "");
        $[0] = editorVersion?.nodes?.[0]?.value;
        $[1] = t1;
    } else t1 = $[1];
    const editorVersionValue = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jsaQN.usePageCardAnalyticsEvents)();
    let t2;
    if ($[2] !== createAnalyticsEvent || $[3] !== isOnEditRoute || $[4] !== type) {
        t2 = ()=>{
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "clicked",
                    actionSubject: "editButton",
                    attributes: {
                        navdexPointType: (0, $56QzY.END),
                        pageType: type,
                        isOnEditRoute: isOnEditRoute
                    }
                }
            }).fire();
        };
        $[2] = createAnalyticsEvent;
        $[3] = isOnEditRoute;
        $[4] = type;
        $[5] = t2;
    } else t2 = $[5];
    const fireClickAnalytics = t2;
    let t3;
    if ($[6] !== editorVersionValue || $[7] !== editui || $[8] !== fireClickAnalytics || $[9] !== id || $[10] !== loadEditor || $[11] !== spaceKey) {
        t3 = (e)=>{
            fireClickAnalytics();
            e.preventDefault();
            e.stopPropagation();
            loadEditor({
                contentId: id,
                spaceKey: spaceKey,
                redirectUrl: `${(0, $jlIaF.CONTEXT_PATH)}${editui}`,
                isFabricSupported: editorVersionValue === "v2",
                isEmbeddedContent: false
            });
        };
        $[6] = editorVersionValue;
        $[7] = editui;
        $[8] = fireClickAnalytics;
        $[9] = id;
        $[10] = loadEditor;
        $[11] = spaceKey;
        $[12] = t3;
    } else t3 = $[12];
    const handleClick = t3;
    let t4;
    if ($[13] !== intl) {
        t4 = intl.formatMessage($cea5a5dbb111468f$var$i18n.edit);
        $[13] = intl;
        $[14] = t4;
    } else t4 = $[14];
    const t5 = compact ? "compact" : "default";
    const t6 = `${(0, $jlIaF.CONTEXT_PATH)}${editui}`;
    let t7;
    if ($[15] !== intl || $[16] !== title.text) {
        t7 = intl.formatMessage($cea5a5dbb111468f$var$i18n.editLabel, {
            title: title.text
        });
        $[15] = intl;
        $[16] = title.text;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        });
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== handleClick || $[20] !== t5 || $[21] !== t6 || $[22] !== t7) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9435f53888e733e2$export$3c1d9e6f68d6384d), {
            spacing: t5,
            onClick: handleClick,
            href: t6,
            appearance: "subtle",
            "aria-label": t7,
            iconBefore: t8
        });
        $[19] = handleClick;
        $[20] = t5;
        $[21] = t6;
        $[22] = t7;
        $[23] = t9;
    } else t9 = $[23];
    let t10;
    if ($[24] !== t4 || $[25] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t4,
            position: "top",
            hideTooltipOnClick: true
        }, t9);
        $[24] = t4;
        $[25] = t9;
        $[26] = t10;
    } else t10 = $[26];
    let t11;
    if ($[27] !== id || $[28] !== spaceKey || $[29] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $146c0ee07cc94a7d$export$37ab3bdebc286ca), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $sD2Tz.EditContentButtonPreloader), {
            key: id,
            contentId: id,
            spaceKey: spaceKey,
            isEmbeddedEditor: false,
            editSource: (0, $7NoF3.PAGECARD_EDIT_BUTTON_CLICK)
        }, t10));
        $[27] = id;
        $[28] = spaceKey;
        $[29] = t10;
        $[30] = t11;
    } else t11 = $[30];
    return t11;
};





/**
 * @generated SignedSource<<296a26ba12532fe922a7008662cde02b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $60219086504fb31b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "StarButtonFolderCardStarFragment",
    "selections": [
        {
            "concreteType": "ConfluenceContentViewerSummary",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceFavoritedSummary",
                    "kind": "LinkedField",
                    "name": "favoritedSummary",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isFavorite"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "ConfluenceFolder"
};
$60219086504fb31b$var$node.hash = "62017b9252e425c5ce11b9dacbcfcca3";
var $60219086504fb31b$export$2e2bcd8739ae039 = $60219086504fb31b$var$node;


/**
 * @generated SignedSource<<2393b4f87f3a5d50240b0670eb471d18>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0d1bb8ea45c63cef$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "StarButtonEmbedCardStarFragment",
    "selections": [
        {
            "concreteType": "ConfluenceContentViewerSummary",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceFavoritedSummary",
                    "kind": "LinkedField",
                    "name": "favoritedSummary",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isFavorite"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "ConfluenceEmbed"
};
$0d1bb8ea45c63cef$var$node.hash = "dae3be06d0fda145c168470989cbd584";
var $0d1bb8ea45c63cef$export$2e2bcd8739ae039 = $0d1bb8ea45c63cef$var$node;


/**
 * @generated SignedSource<<f6a9edfc0dc9e8ccebd02c4c93262277>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $51602afe7d2fd9c6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "StarButtonDatabaseCardStarFragment",
    "selections": [
        {
            "concreteType": "ConfluenceContentViewerSummary",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceFavoritedSummary",
                    "kind": "LinkedField",
                    "name": "favoritedSummary",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isFavorite"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "ConfluenceDatabase"
};
$51602afe7d2fd9c6$var$node.hash = "a81f85b886dc8719dc1edb9584fcf248";
var $51602afe7d2fd9c6$export$2e2bcd8739ae039 = $51602afe7d2fd9c6$var$node;


/**
 * @generated SignedSource<<94193beed8f0aba24e02d2267ddcfaa8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $dcdb90ac554843b3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "StarButtonWhiteboardCardStarFragment",
    "selections": [
        {
            "concreteType": "ConfluenceContentViewerSummary",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceFavoritedSummary",
                    "kind": "LinkedField",
                    "name": "favoritedSummary",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isFavorite"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "ConfluenceWhiteboard"
};
$dcdb90ac554843b3$var$node.hash = "85a390774d106b96e51ecf04f0dab5fb";
var $dcdb90ac554843b3$export$2e2bcd8739ae039 = $dcdb90ac554843b3$var$node;


/**
 * @generated SignedSource<<13f4bca056f3977b645e1b9125894a3b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $be47f1068f5cc3f9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "StarButtonBlogPostCardStarFragment",
    "selections": [
        {
            "concreteType": "ConfluenceBlogPostViewerSummary",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceFavoritedSummary",
                    "kind": "LinkedField",
                    "name": "favoritedSummary",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isFavorite"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "ConfluenceBlogPost"
};
$be47f1068f5cc3f9$var$node.hash = "2f3c7e7edda1297f958e48ce6c8828a2";
var $be47f1068f5cc3f9$export$2e2bcd8739ae039 = $be47f1068f5cc3f9$var$node;


/**
 * @generated SignedSource<<69b3baefe0333fdf456c4ea2185c88d1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5fab506cdf63b5d3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "StarButtonPageCardStarFragment",
    "selections": [
        {
            "concreteType": "ConfluencePageViewerSummary",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceFavoritedSummary",
                    "kind": "LinkedField",
                    "name": "favoritedSummary",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isFavorite"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "ConfluencePage"
};
$5fab506cdf63b5d3$var$node.hash = "b8d1619a003756cf35c8239d88418099";
var $5fab506cdf63b5d3$export$2e2bcd8739ae039 = $5fab506cdf63b5d3$var$node;


/**
 * @generated SignedSource<<53e3d2f1e0dd97bd9cc2ebc1de16188b>>
 * @relayHash 865e5f39a31798c3bb25a35cece32ea9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c7cb2b55e80c6bfdd66ab8055ac299fa039a70c5cd23209c338ec4b5427aed5f
const $0ef52d4ce61ef798$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "id"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "favouritePageInput"
                }
            ],
            "concreteType": "FavouritePagePayload",
            "kind": "LinkedField",
            "name": "unfavouritePage",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                    "kind": "LinkedField",
                                    "name": "currentuser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "FavouritedSummary",
                                            "kind": "LinkedField",
                                            "name": "favourited",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "StarButtonPageCardUnstarMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "StarButtonPageCardUnstarMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "865e5f39a31798c3bb25a35cece32ea9",
            "id": "c7cb2b55e80c6bfdd66ab8055ac299fa039a70c5cd23209c338ec4b5427aed5f",
            "metadata": {},
            "name": "StarButtonPageCardUnstarMutation",
            "operationKind": "mutation",
            "text": "mutation StarButtonPageCardUnstarMutation($id:ID!){unfavouritePage(favouritePageInput:{pageId:$id}){content{id,metadata{currentuser{favourited{isFavourite}}}}}}"
        }
    };
}();
$0ef52d4ce61ef798$var$node.hash = "992270a31fd5c901695e35d84cb8d30a";
var $0ef52d4ce61ef798$export$2e2bcd8739ae039 = $0ef52d4ce61ef798$var$node;


/**
 * @generated SignedSource<<bcc0b5c5ffe1423cec0c471be11102f3>>
 * @relayHash 70c92872d8ccc540bcc28f7f9fc3a1e4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4dead3f6527350b99aa2c5192fc9e4c257375934c52323e1c2158604badf0027
const $0e3ed881e0768c90$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "id"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "favouritePageInput"
                }
            ],
            "concreteType": "FavouritePagePayload",
            "kind": "LinkedField",
            "name": "favouritePage",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                    "kind": "LinkedField",
                                    "name": "currentuser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "FavouritedSummary",
                                            "kind": "LinkedField",
                                            "name": "favourited",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "StarButtonPageCardStarMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "StarButtonPageCardStarMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "70c92872d8ccc540bcc28f7f9fc3a1e4",
            "id": "4dead3f6527350b99aa2c5192fc9e4c257375934c52323e1c2158604badf0027",
            "metadata": {},
            "name": "StarButtonPageCardStarMutation",
            "operationKind": "mutation",
            "text": "mutation StarButtonPageCardStarMutation($id:ID!){favouritePage(favouritePageInput:{pageId:$id}){content{id,metadata{currentuser{favourited{isFavourite}}}}}}"
        }
    };
}();
$0e3ed881e0768c90$var$node.hash = "f8033abcb2133c170a7481a2b9cff941";
var $0e3ed881e0768c90$export$2e2bcd8739ae039 = $0e3ed881e0768c90$var$node;









var $lbT4j = parcelRequire("lbT4j");





var $b3j2Y = parcelRequire("b3j2Y");


var $bvJMy = parcelRequire("bvJMy");


var $gw4Eo = parcelRequire("gw4Eo");





var $ij4CE = parcelRequire("ij4CE");















// For forming the typename correctly for content types to enable optimistic updates
const $b6404efbbcc25998$var$capitalizedContentTypes = {
    page: 'Page',
    blogpost: 'BlogPost',
    database: 'Database',
    whiteboard: 'Whiteboard',
    slide: 'Slide',
    embed: 'Embed',
    folder: 'Folder'
};
const $b6404efbbcc25998$export$caa6fc1b5639be76 = (type)=>$b6404efbbcc25998$var$capitalizedContentTypes[type];



var $308Wd = parcelRequire("308Wd");

const $04fcbb12dec9cb03$var$StarButtonPageCardStarMutation = (0, $0e3ed881e0768c90$export$2e2bcd8739ae039);
const $04fcbb12dec9cb03$var$StarButtonPageCardUnstarMutation = (0, $0ef52d4ce61ef798$export$2e2bcd8739ae039);
const $04fcbb12dec9cb03$var$i18n = (0, $kSwu1.defineMessages)({
    star: {
        id: "page-card.star.content.tooltip.label",
        defaultMessage: "Star"
    },
    unstar: {
        id: "page-card.unstar.content.tooltip.label",
        defaultMessage: "Unstar"
    }
});
const $04fcbb12dec9cb03$export$b4b5678234ca6d4d = ()=>{
    const $ = (0, $bDgLe.c)(54);
    const { id: id, type: type, isStarred: isStarred, appearance: appearance } = (0, $cozmU.useContext)((0, $AXitC.PageCardContext));
    const intl = (0, $kSwu1.useIntl)();
    const compact = appearance === "compact-list";
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jsaQN.usePageCardAnalyticsEvents)();
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            fragmentArtifact: (0, $5fab506cdf63b5d3$export$2e2bcd8739ae039),
            fragmentSpec: (0, $5fab506cdf63b5d3$export$2e2bcd8739ae039)
        };
        $[0] = t0;
    } else t0 = $[0];
    const writePageStarButtonFragment = (0, $ij4CE.useWriteFragmentInterop)({
        ...t0,
        __callerPackage__: "page-card"
    });
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            fragmentArtifact: (0, $be47f1068f5cc3f9$export$2e2bcd8739ae039),
            fragmentSpec: (0, $be47f1068f5cc3f9$export$2e2bcd8739ae039)
        };
        $[1] = t1;
    } else t1 = $[1];
    const writeBlogPostStarButtonFragment = (0, $ij4CE.useWriteFragmentInterop)({
        ...t1,
        __callerPackage__: "page-card"
    });
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            fragmentArtifact: (0, $dcdb90ac554843b3$export$2e2bcd8739ae039),
            fragmentSpec: (0, $dcdb90ac554843b3$export$2e2bcd8739ae039)
        };
        $[2] = t2;
    } else t2 = $[2];
    const writeWhiteboardStarButtonFragment = (0, $ij4CE.useWriteFragmentInterop)({
        ...t2,
        __callerPackage__: "page-card"
    });
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            fragmentArtifact: (0, $51602afe7d2fd9c6$export$2e2bcd8739ae039),
            fragmentSpec: (0, $51602afe7d2fd9c6$export$2e2bcd8739ae039)
        };
        $[3] = t3;
    } else t3 = $[3];
    const writeDatabaseStarButtonFragment = (0, $ij4CE.useWriteFragmentInterop)({
        ...t3,
        __callerPackage__: "page-card"
    });
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            fragmentArtifact: (0, $0d1bb8ea45c63cef$export$2e2bcd8739ae039),
            fragmentSpec: (0, $0d1bb8ea45c63cef$export$2e2bcd8739ae039)
        };
        $[4] = t4;
    } else t4 = $[4];
    const writeEmbedStarButtonFragment = (0, $ij4CE.useWriteFragmentInterop)({
        ...t4,
        __callerPackage__: "page-card"
    });
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            fragmentArtifact: (0, $60219086504fb31b$export$2e2bcd8739ae039),
            fragmentSpec: (0, $60219086504fb31b$export$2e2bcd8739ae039)
        };
        $[5] = t5;
    } else t5 = $[5];
    const writeFolderStarButtonFragment = (0, $ij4CE.useWriteFragmentInterop)({
        ...t5,
        __callerPackage__: "page-card"
    });
    const [star, t6] = (0, $308Wd.useMutationInterop)($04fcbb12dec9cb03$var$StarButtonPageCardStarMutation, {
        __callerPackage__: "page-card"
    });
    const { error: starError } = t6;
    const [unstar, t7] = (0, $308Wd.useMutationInterop)($04fcbb12dec9cb03$var$StarButtonPageCardUnstarMutation, {
        __callerPackage__: "page-card"
    });
    const { error: unstarError } = t7;
    const buttonRef = (0, $cozmU.useRef)(null);
    const shouldRestoreFocusRef = (0, $cozmU.useRef)(false);
    let t8;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = ()=>{
            if (shouldRestoreFocusRef.current) {
                shouldRestoreFocusRef.current = false;
                buttonRef.current?.focus();
            }
        };
        $[6] = t8;
    } else t8 = $[6];
    let t9;
    if ($[7] !== isStarred) {
        t9 = [
            isStarred
        ];
        $[7] = isStarred;
        $[8] = t9;
    } else t9 = $[8];
    (0, $cozmU.useEffect)(t8, t9);
    let t10;
    if ($[9] !== createAnalyticsEvent || $[10] !== type) {
        t10 = (action)=>{
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: action,
                    actionSubject: "favouritePage",
                    attributes: {
                        type: type
                    }
                }
            }).fire();
        };
        $[9] = createAnalyticsEvent;
        $[10] = type;
        $[11] = t10;
    } else t10 = $[11];
    const sendAnalyticsEvent = t10;
    let t11;
    if ($[12] !== activationId || $[13] !== cloudId || $[14] !== id || $[15] !== type || $[16] !== writeBlogPostStarButtonFragment || $[17] !== writeDatabaseStarButtonFragment || $[18] !== writeEmbedStarButtonFragment || $[19] !== writeFolderStarButtonFragment || $[20] !== writePageStarButtonFragment || $[21] !== writeWhiteboardStarButtonFragment) {
        t11 = (t12)=>{
            const { newStarredValue: newStarredValue, useAggClient: t13 } = t12;
            const useAggClient = t13 === undefined ? false : t13;
            const capitalizedType = (0, $b6404efbbcc25998$export$caa6fc1b5639be76)(type);
            const dataTypename = `Confluence${capitalizedType}`;
            const starButtonRelayFragments = {
                page: writePageStarButtonFragment,
                blogpost: writeBlogPostStarButtonFragment,
                whiteboard: writeWhiteboardStarButtonFragment,
                slide: writeWhiteboardStarButtonFragment,
                database: writeDatabaseStarButtonFragment,
                embed: writeEmbedStarButtonFragment,
                folder: writeFolderStarButtonFragment
            };
            const writeStarButtonFragment = (type_0)=>starButtonRelayFragments[type_0];
            writeStarButtonFragment(type)({
                fragmentId: `${dataTypename}:${(0, $gw4Eo.getConfluenceContentAri)({
                    siteId: cloudId,
                    resourceType: type,
                    activationId: activationId,
                    resourceId: id
                })}`,
                useAggClient: useAggClient,
                data: {
                    viewer: {
                        favoritedSummary: {
                            isFavorite: newStarredValue,
                            __typename: "ConfluenceFavoritedSummary"
                        },
                        __typename: `Confluence${capitalizedType}ViewerSummary`
                    },
                    __typename: dataTypename
                }
            });
        };
        $[12] = activationId;
        $[13] = cloudId;
        $[14] = id;
        $[15] = type;
        $[16] = writeBlogPostStarButtonFragment;
        $[17] = writeDatabaseStarButtonFragment;
        $[18] = writeEmbedStarButtonFragment;
        $[19] = writeFolderStarButtonFragment;
        $[20] = writePageStarButtonFragment;
        $[21] = writeWhiteboardStarButtonFragment;
        $[22] = t11;
    } else t11 = $[22];
    const modifyStarCache = t11;
    let t12;
    if ($[23] !== id || $[24] !== modifyStarCache || $[25] !== sendAnalyticsEvent || $[26] !== star) {
        t12 = (e)=>{
            e.stopPropagation();
            shouldRestoreFocusRef.current = true;
            star({
                variables: {
                    id: id
                },
                optimisticResponse: {
                    favouritePage: {
                        __typename: "FavouritePagePayload",
                        content: {
                            __typename: "Content",
                            id: id,
                            metadata: {
                                __typename: "ContentMetadata",
                                currentuser: {
                                    __typename: "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                    favourited: {
                                        __typename: "FavouritedSummary",
                                        isFavourite: true
                                    }
                                }
                            }
                        }
                    }
                }
            });
            sendAnalyticsEvent("created");
            modifyStarCache({
                newStarredValue: true,
                useAggClient: true
            });
        };
        $[23] = id;
        $[24] = modifyStarCache;
        $[25] = sendAnalyticsEvent;
        $[26] = star;
        $[27] = t12;
    } else t12 = $[27];
    const onStarClick = t12;
    let t13;
    if ($[28] !== id || $[29] !== modifyStarCache || $[30] !== sendAnalyticsEvent || $[31] !== unstar) {
        t13 = (e_0)=>{
            e_0.stopPropagation();
            shouldRestoreFocusRef.current = true;
            unstar({
                variables: {
                    id: id
                },
                optimisticResponse: {
                    unfavouritePage: {
                        __typename: "FavouritePagePayload",
                        content: {
                            __typename: "Content",
                            id: id,
                            metadata: {
                                __typename: "ContentMetadata",
                                currentuser: {
                                    __typename: "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                    favourited: null
                                }
                            }
                        }
                    }
                }
            });
            sendAnalyticsEvent("deleted");
            modifyStarCache({
                newStarredValue: false,
                useAggClient: true
            });
        };
        $[28] = id;
        $[29] = modifyStarCache;
        $[30] = sendAnalyticsEvent;
        $[31] = unstar;
        $[32] = t13;
    } else t13 = $[32];
    const onUnstarClick = t13;
    let t14;
    if ($[33] !== intl || $[34] !== isStarred) {
        t14 = isStarred ? intl.formatMessage($04fcbb12dec9cb03$var$i18n.unstar) : intl.formatMessage($04fcbb12dec9cb03$var$i18n.star);
        $[33] = intl;
        $[34] = isStarred;
        $[35] = t14;
    } else t14 = $[35];
    const tooltipLabel = t14;
    let t15;
    if ($[36] !== starError) {
        t15 = starError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: starError
        });
        $[36] = starError;
        $[37] = t15;
    } else t15 = $[37];
    let t16;
    if ($[38] !== unstarError) {
        t16 = unstarError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: unstarError
        });
        $[38] = unstarError;
        $[39] = t16;
    } else t16 = $[39];
    let t17;
    if ($[40] !== compact || $[41] !== id || $[42] !== intl || $[43] !== isStarred || $[44] !== onStarClick || $[45] !== onUnstarClick) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, isStarred ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9435f53888e733e2$export$3c1d9e6f68d6384d), {
            ref: buttonRef,
            id: `star-button-${id}`,
            spacing: compact ? "compact" : "default",
            appearance: "subtle",
            onClick: onUnstarClick,
            "aria-label": intl.formatMessage($04fcbb12dec9cb03$var$i18n.star),
            "aria-pressed": isStarred,
            "aria-labelledby": `star-button-${id} content-title-${id}`,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bvJMy.StarSelectedIcon), {
                label: ""
            }),
            testId: "page-unstar-button"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $146c0ee07cc94a7d$export$37ab3bdebc286ca), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9435f53888e733e2$export$3c1d9e6f68d6384d), {
            ref: buttonRef,
            id: `star-button-${id}`,
            spacing: compact ? "compact" : "default",
            appearance: "subtle",
            onClick: onStarClick,
            "aria-label": intl.formatMessage($04fcbb12dec9cb03$var$i18n.star),
            "aria-pressed": isStarred,
            "aria-labelledby": `star-button-${id} content-title-${id}`,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
                label: ""
            }),
            testId: "page-star-button"
        })));
        $[40] = compact;
        $[41] = id;
        $[42] = intl;
        $[43] = isStarred;
        $[44] = onStarClick;
        $[45] = onUnstarClick;
        $[46] = t17;
    } else t17 = $[46];
    let t18;
    if ($[47] !== t17 || $[48] !== tooltipLabel) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: tooltipLabel,
            position: "top",
            hideTooltipOnClick: true
        }, t17);
        $[47] = t17;
        $[48] = tooltipLabel;
        $[49] = t18;
    } else t18 = $[49];
    let t19;
    if ($[50] !== t15 || $[51] !== t16 || $[52] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t15, t16, t18);
        $[50] = t15;
        $[51] = t16;
        $[52] = t18;
        $[53] = t19;
    } else t19 = $[53];
    return t19;
};












var $a79Sy = parcelRequire("a79Sy");


var $XgBmC = parcelRequire("XgBmC");





var $jmjWc = parcelRequire("jmjWc");


var $bl4QJ = parcelRequire("bl4QJ");


const $6572a38c2b754de3$export$7a3e91558b835213 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "G6aNu",
    name: "WatchDialog",
    loader: async ()=>(await (parcelRequire("jYcXA"))).WatchDialog,
    loading: (0, $bl4QJ.WatchButtonPlaceholder)
});



var $5EoFB = parcelRequire("5EoFB");















var $7tW57 = parcelRequire("7tW57");

const $ac97a98bde54329f$export$8091e3849c182a6 = (menuItem, isSelected)=>{
    const { setIsMenuOpen: setIsMenuOpen, setSelectedMenuItems: setSelectedMenuItems, selectedMenuItems: selectedMenuItems } = (0, $cozmU.useContext)((0, $AXitC.PageCardContext));
    (0, $cozmU.useEffect)(()=>{
        setSelectedMenuItems({
            ...selectedMenuItems,
            [menuItem]: isSelected
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isSelected
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (selectedMenuItems[(0, $7tW57.QuickActionsEnum).WatchButton]) setIsMenuOpen(true);
        else setIsMenuOpen(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedMenuItems
    ]);
};








const $c75091fbd7089ca4$var$i18n = (0, $kSwu1.defineMessages)({
    watch: {
        id: "page-card.quick-actions.watch.page",
        defaultMessage: "Watch"
    },
    unwatch: {
        id: "page-card.quick-actions.unwatch.page",
        defaultMessage: "Unwatch"
    },
    watchLabel: {
        id: "page-card.quick-actions.watch.aria-label",
        defaultMessage: "Watch {title}"
    },
    unwatchLabel: {
        id: "page-card.quick-actions.unwatch.aria-label",
        defaultMessage: "Unwatch {title}"
    }
});
const $c75091fbd7089ca4$export$41b9225b77f84823 = (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { isWatching: isWatching, isSelected: isSelected, triggerProps: triggerProps, onClick: onClick, onMouseOver: onMouseOver } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jsaQN.usePageCardAnalyticsEvents)();
    (0, $ac97a98bde54329f$export$8091e3849c182a6)((0, $7tW57.QuickActionsEnum).WatchButton, isSelected);
    const { type: type, appearance: appearance, title: title } = (0, $cozmU.useContext)((0, $AXitC.PageCardContext));
    const intl = (0, $kSwu1.useIntl)();
    const compact = appearance === "compact-list";
    let t1;
    if ($[0] !== intl || $[1] !== isWatching || $[2] !== title.text) {
        t1 = isWatching ? [
            (0, (/*@__PURE__*/$parcel$interopDefault($XgBmC))),
            intl.formatMessage($c75091fbd7089ca4$var$i18n.unwatch),
            intl.formatMessage($c75091fbd7089ca4$var$i18n.unwatchLabel, {
                title: title.text
            })
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($a79Sy))),
            intl.formatMessage($c75091fbd7089ca4$var$i18n.watch),
            intl.formatMessage($c75091fbd7089ca4$var$i18n.watchLabel, {
                title: title.text
            })
        ];
        $[0] = intl;
        $[1] = isWatching;
        $[2] = title.text;
        $[3] = t1;
    } else t1 = $[3];
    const [Icon, label, ariaLabel] = t1;
    let t2;
    if ($[4] !== createAnalyticsEvent || $[5] !== onClick || $[6] !== type) {
        t2 = ()=>{
            onClick();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "content-watch-button",
                    attributes: {
                        contentType: type
                    }
                }
            }).fire();
        };
        $[4] = createAnalyticsEvent;
        $[5] = onClick;
        $[6] = type;
        $[7] = t2;
    } else t2 = $[7];
    const handleWatchClick = t2;
    const t3 = compact ? "compact" : "default";
    let t4;
    if ($[8] !== Icon) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: ""
        });
        $[8] = Icon;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== triggerProps) {
        t5 = triggerProps || {};
        $[10] = triggerProps;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== ariaLabel || $[13] !== handleWatchClick || $[14] !== isSelected || $[15] !== onMouseOver || $[16] !== t3 || $[17] !== t4 || $[18] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9435f53888e733e2$export$3c1d9e6f68d6384d), {
            spacing: t3,
            appearance: "subtle",
            onClick: handleWatchClick,
            onMouseOver: onMouseOver,
            isSelected: isSelected,
            "aria-label": ariaLabel,
            iconBefore: t4,
            ...t5
        }));
        $[12] = ariaLabel;
        $[13] = handleWatchClick;
        $[14] = isSelected;
        $[15] = onMouseOver;
        $[16] = t3;
        $[17] = t4;
        $[18] = t5;
        $[19] = t6;
    } else t6 = $[19];
    let t7;
    if ($[20] !== label || $[21] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: label,
            position: "top",
            hideTooltipOnClick: true
        }, t6);
        $[20] = label;
        $[21] = t6;
        $[22] = t7;
    } else t7 = $[22];
    return t7;
};
const $c75091fbd7089ca4$export$e149a93a7ac7f896 = ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { id: id, appearance: appearance, isViewed: isViewed } = (0, $cozmU.useContext)((0, $AXitC.PageCardContext));
    const compact = appearance === "compact-list";
    let t0;
    if ($[0] !== compact || $[1] !== id || $[2] !== isViewed) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $146c0ee07cc94a7d$export$37ab3bdebc286ca), null, isViewed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6572a38c2b754de3$export$7a3e91558b835213), {
            contentId: id,
            defaultTab: (0, $5EoFB.MANAGE_WATCHER_TAB_TYPES).PAGE,
            customTrigger: $c75091fbd7089ca4$export$41b9225b77f84823,
            useShortcut: false,
            compact: compact
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bl4QJ.WatchButtonPlaceholder), {
            compact: compact
        }));
        $[0] = compact;
        $[1] = id;
        $[2] = isViewed;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
};









var $hkzol = parcelRequire("hkzol");





const $6e589e112b83e5ab$export$534d10f1c5b9c7b3 = (_)=>{
    const $ = (0, $bDgLe.c)(5);
    const { id: contentId, type: contentType, space: space, analyticsData: analyticsData } = (0, $cozmU.useContext)((0, $AXitC.PageCardContext));
    const t0 = space?.spaceKey ?? "";
    const t1 = analyticsData?.source ?? "";
    let t2;
    if ($[0] !== contentId || $[1] !== contentType || $[2] !== t0 || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $146c0ee07cc94a7d$export$37ab3bdebc286ca), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hkzol.CopyLinkButton), {
            contentId: contentId,
            contentType: contentType,
            spaceKey: t0,
            source: t1,
            buttonAppearance: "subtle",
            tooltipPosition: "top"
        }));
        $[0] = contentId;
        $[1] = contentType;
        $[2] = t0;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};


const $7f1b580bd70ac23d$export$e53fea40f770c4e5 = /*#__PURE__*/ (0, $cozmU.createContext)({
    hidden: true
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7f1b580bd70ac23d$var$QuickActionsContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "ul" : t5;
        const { compact: compact, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _1LMyvKYbGa _3iDTPbQ4SZ _0hPCNLDIqT",
            __cmplp.compact ? "_37wbyuz9WS" : "_37wbyuZqHV",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $7f1b580bd70ac23d$var$QuickActionsListItem = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "li" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_313842dnbC",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $7f1b580bd70ac23d$var$PlaceholderAction = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "li" : t5;
        const { compact: compact, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_39xV02Uofl _313842dnbC",
            __cmplp.compact ? "_0jFU0VoWWg" : "_0jFU0VUofl",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $7f1b580bd70ac23d$var$defaultActions = [
    'edit',
    'copy',
    'watch',
    'star'
];
const $7f1b580bd70ac23d$var$useEnabledActions = ()=>{
    const $ = (0, $bDgLe.c)(21);
    const isStarringEnabledForDatabases = (0, $2cKGu.useIsStarringEnabled)("database");
    const isWatchingWhiteboardsEnabled = (0, $660080b0a61a732e$export$75ba55e1c62d2f65)("whiteboard");
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { status: status, type: type, subType: subType } = (0, $cozmU.useContext)((0, $AXitC.PageCardContext));
    if (!isLicensed || status === "draft") {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = [];
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    let t0;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            "copy",
            "star"
        ];
        $[1] = t0;
    } else t0 = $[1];
    const contentActions = t0;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            "watch"
        ];
        $[2] = t1;
    } else t1 = $[2];
    const watchAction = t1;
    let t2;
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        const livePageActions = $7f1b580bd70ac23d$var$defaultActions.filter($7f1b580bd70ac23d$var$_temp);
        t2 = {
            none: $7f1b580bd70ac23d$var$defaultActions,
            live: livePageActions
        };
        t3 = {
            none: $7f1b580bd70ac23d$var$defaultActions
        };
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    let t4;
    if ($[5] !== isWatchingWhiteboardsEnabled) {
        t4 = {
            none: [
                ...contentActions,
                ...isWatchingWhiteboardsEnabled ? watchAction : []
            ]
        };
        $[5] = isWatchingWhiteboardsEnabled;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isWatchingWhiteboardsEnabled) {
        t5 = {
            none: [
                ...contentActions,
                ...isWatchingWhiteboardsEnabled ? watchAction : []
            ]
        };
        $[7] = isWatchingWhiteboardsEnabled;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== isStarringEnabledForDatabases) {
        t6 = {
            none: isStarringEnabledForDatabases ? contentActions : []
        };
        $[9] = isStarringEnabledForDatabases;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    let t8;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = {
            none: contentActions
        };
        t8 = {
            none: contentActions
        };
        $[11] = t7;
        $[12] = t8;
    } else {
        t7 = $[11];
        t8 = $[12];
    }
    let t9;
    if ($[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
        t9 = {
            page: t2,
            blogpost: t3,
            whiteboard: t4,
            slide: t5,
            database: t6,
            embed: t7,
            folder: t8
        };
        $[13] = t4;
        $[14] = t5;
        $[15] = t6;
        $[16] = t9;
    } else t9 = $[16];
    const typeActionMap = t9;
    let t10;
    if ($[17] !== subType || $[18] !== type || $[19] !== typeActionMap) {
        t10 = typeActionMap[type]?.[subType ?? "none"] || [];
        $[17] = subType;
        $[18] = type;
        $[19] = typeActionMap;
        $[20] = t10;
    } else t10 = $[20];
    return t10;
};
const $7f1b580bd70ac23d$export$626874e33f1a0310 = (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { actions: t1, hidden: hidden, compact: compact } = t0;
    const actions = t1 === undefined ? $7f1b580bd70ac23d$var$defaultActions : t1;
    const enabledActions = $7f1b580bd70ac23d$var$useEnabledActions();
    const numberOfPlaceholders = $7f1b580bd70ac23d$var$defaultActions.length - enabledActions.length;
    const t2 = Boolean(hidden);
    let t3;
    if ($[0] !== t2) {
        t3 = {
            hidden: t2
        };
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    const quickActionsContextValue = t3;
    let t4;
    if ($[2] !== compact || $[3] !== numberOfPlaceholders) {
        let t5;
        if ($[5] !== compact) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f1b580bd70ac23d$var$PlaceholderAction, {
                compact: compact
            });
            $[5] = compact;
            $[6] = t5;
        } else t5 = $[6];
        t4 = Array(numberOfPlaceholders).fill(t5);
        $[2] = compact;
        $[3] = numberOfPlaceholders;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[7] !== actions || $[8] !== enabledActions) {
        let t6;
        if ($[10] !== enabledActions) {
            t6 = (action)=>{
                let actionButton;
                bb8: switch(enabledActions.includes(action) ? action : null){
                    case "edit":
                        actionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cea5a5dbb111468f$export$a8d3280cb45e38b8), {
                            key: action
                        });
                        break bb8;
                    case "copy":
                        actionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6e589e112b83e5ab$export$534d10f1c5b9c7b3), {
                            key: action
                        });
                        break bb8;
                    case "watch":
                        actionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c75091fbd7089ca4$export$e149a93a7ac7f896), {
                            key: action
                        });
                        break bb8;
                    case "star":
                        actionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $04fcbb12dec9cb03$export$b4b5678234ca6d4d), {
                            key: action
                        });
                        break bb8;
                    default:
                        actionButton = null;
                }
                return actionButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f1b580bd70ac23d$var$QuickActionsListItem, {
                    key: action
                }, actionButton) : null;
            };
            $[10] = enabledActions;
            $[11] = t6;
        } else t6 = $[11];
        t5 = actions.map(t6);
        $[7] = actions;
        $[8] = enabledActions;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[12] !== compact || $[13] !== t4 || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f1b580bd70ac23d$var$QuickActionsContainer, {
            compact: compact
        }, t4, t5);
        $[12] = compact;
        $[13] = t4;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] !== quickActionsContextValue || $[17] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f1b580bd70ac23d$export$e53fea40f770c4e5.Provider, {
            value: quickActionsContextValue
        }, t6);
        $[16] = quickActionsContextValue;
        $[17] = t6;
        $[18] = t7;
    } else t7 = $[18];
    return t7;
};
function $7f1b580bd70ac23d$var$_temp(item) {
    return item !== "edit";
}


var $fROKr = parcelRequire("fROKr");

var $eSkJX = parcelRequire("eSkJX");

var $63k9q = parcelRequire("63k9q");


var $4xawV = parcelRequire("4xawV");

const $838b83bb70ba05a9$var$listCardStyle = null;
const $838b83bb70ba05a9$var$gridTemplateColumnsMap = {
    FULL: '32px minmax(300px, 2fr) 1fr 1fr 128px',
    NO_LAST_ACTION: '32px minmax(300px, 2fr) 1fr 0fr 128px',
    NO_SUBTITLE: '32px minmax(300px, 2fr) 0fr 0fr 128px'
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $838b83bb70ba05a9$var$StyledCard = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $dDr80.Card) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_30huDKOeNX _0bjKvDdnbC _1x1D3gYbGa _2OUyjtYbGa _3fSdSTYbGa _1eOmH6mhAQ _4sqQ6sZpcK",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $838b83bb70ba05a9$var$TitleContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _4ouGXIdnbC",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $838b83bb70ba05a9$var$ContentIconContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0adFHs5zaO _0jFU0Vey7F _3iDTPbQ4SZ _0hPCNLDIqT",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $838b83bb70ba05a9$var$RoundedCornerContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2bBGm88fU6 _4gC8ri8fU6",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $838b83bb70ba05a9$var$TitleText = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _0adFHs2ADO _1ANEUSLRg7 _39HuIbz8Lp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $838b83bb70ba05a9$var$statusContainerStyles = (0, $buxP3.xcss)({
    marginRight: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $838b83bb70ba05a9$var$SubtitleContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _0adFHs2ADO _3iDTPbQ4SZ _0hPCNLDIqT",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $838b83bb70ba05a9$var$LastActionContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _0adFHs2ADO",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $838b83bb70ba05a9$export$f9e5c039a4efefae = ()=>{
    const $ = (0, $bDgLe.c)(12);
    const { width: width } = (0, $cozmU.useContext)((0, $4xawV.PageCardsContext));
    let breakPoint = "FULL";
    if (width < 700) breakPoint = "NO_SUBTITLE";
    else if (width < 900) breakPoint = "NO_LAST_ACTION";
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9CEYG.PageLink), {
            compact: true
        });
        $[0] = t0;
    } else t0 = $[0];
    const t1 = $838b83bb70ba05a9$var$gridTemplateColumnsMap[breakPoint];
    let t2;
    if ($[1] !== t1) {
        t2 = {
            gridTemplateColumns: t1
        };
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            "_4FKVYEzcuf _4ouGXIdnbC _3iDTPbgBM8 _0hPCNLDIqT"
        ]);
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($838b83bb70ba05a9$var$ContentIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aoeyL.ContentIcon), null));
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($838b83bb70ba05a9$var$TitleText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $63k9q.Title), {
            singleLine: true
        }));
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($838b83bb70ba05a9$var$TitleContainer, null, t5, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $838b83bb70ba05a9$var$statusContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fROKr.StatusLozenge), null)));
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($838b83bb70ba05a9$var$SubtitleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eSkJX.Subtitle), null));
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    let t9;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($838b83bb70ba05a9$var$LastActionContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c9Olr.LastAction), null));
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7f1b580bd70ac23d$export$626874e33f1a0310), {
            hidden: true,
            compact: true
        });
        $[8] = t8;
        $[9] = t9;
    } else {
        t8 = $[8];
        t9 = $[9];
    }
    let t10;
    if ($[10] !== t2) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($838b83bb70ba05a9$var$RoundedCornerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dDr80.PageCardContainer), {
            StyledCard: $838b83bb70ba05a9$var$StyledCard,
            isListitem: true
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: t2,
            "data-testid": "page-card-compact-list-view",
            className: t3
        }, t4, t6, t7, t8, t9)));
        $[10] = t2;
        $[11] = t10;
    } else t10 = $[11];
    return t10;
};


var $kzTi3 = parcelRequire("kzTi3");










var $4ez2K = parcelRequire("4ez2K");




var $gETnG = parcelRequire("gETnG");







var $1R1bQ = parcelRequire("1R1bQ");







// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $87f8c933d272d979$var$GridCard = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4FKVYEMJXG _3iDTPbQ4SZ _0aFT5vbt8w _0jFU0V7Kmv _39xV02GJbM _0NUa3re7g8",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $87f8c933d272d979$var$TitleContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2XghbEWR26 _2sNsIgWSk4 _4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _3zvHkHwPeg _3iDTPbgJ9S _4Gn54RiZR3 _1U1ZhbbI28",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $87f8c933d272d979$var$FooterContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNOdnbC _1bHrqEIZbP _3iDTPbQ4SZ _0hPCNLz9WS",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $87f8c933d272d979$var$Footer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_39xV02N91d _3138425zaO _3iDTPbQ4SZ _37wbyuI7V3 _0hPCNLDIqT",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $87f8c933d272d979$export$5a87d90ca5d04034 = ()=>{
    const $ = (0, $bDgLe.c)(7);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9CEYG.PageLink), null);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            alignItems: "center",
            justifyContent: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aoeyL.ContentIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7f1b580bd70ac23d$export$626874e33f1a0310), {
            hidden: true
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    let t3;
    let t4;
    let t5;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87f8c933d272d979$var$TitleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $63k9q.Title), null));
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eSkJX.Subtitle), null);
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fROKr.StatusLozenge), {
            isInColumn: true
        });
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gETnG.Excerpt), null);
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
    } else {
        t2 = $[2];
        t3 = $[3];
        t4 = $[4];
        t5 = $[5];
    }
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dDr80.PageCardContainer), {
            isListitem: true
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87f8c933d272d979$var$GridCard, {
            "data-testid": "page-card-grid-view"
        }, t1, t2, t3, t4, t5, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87f8c933d272d979$var$FooterContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87f8c933d272d979$var$Footer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c9Olr.LastAction), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1R1bQ.SocialProof), null)))));
        $[6] = t6;
    } else t6 = $[6];
    return t6;
};

/* ListView.tsx generated by @compiled/babel-plugin v3.0.2 */ 




















'use no memo';
const $089b4dc59c13daf7$var$listCardStyles = null;
const $089b4dc59c13daf7$var$titleContainerStyles = null;
const $089b4dc59c13daf7$var$contentIconStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $089b4dc59c13daf7$var$MainContentContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEB6f5 _4xdlr0chRC _4ouGXIBfNa",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $089b4dc59c13daf7$var$TitleText = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _0adFHs2ADO _1ANEUSLRg7 _39HuIbz8Lp",
            __cmplp.className
        ])
    });
});
const $089b4dc59c13daf7$var$lastActionContainerStyles = null;
const $089b4dc59c13daf7$export$84d0dd190d551cd1 = ()=>{
    // ⚠️ WARNING: Do you need to add conditional logic? Please refer to README#Views ⚠️
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dDr80.PageCardContainer), {
        isListitem: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9CEYG.PageLink), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "page-card-list-view",
        className: (0, $hekY6.default)([
            "_4FKVYEzcuf _4ouGXIdnbC _3iDTPbQ4SZ _0hPCNLDIqT"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2XghbEKam8 _4xdlr0chRC"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aoeyL.ContentIcon), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($089b4dc59c13daf7$var$MainContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($089b4dc59c13daf7$var$TitleText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $63k9q.Title), {
        singleLine: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fROKr.StatusLozenge), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eSkJX.Subtitle), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7f1b580bd70ac23d$export$626874e33f1a0310), {
        hidden: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2O5VijdnbC _3YEZNO7dHp _1bHrqEPIoL _4ouGXIQEt6 _2fwxA50dzo"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c9Olr.LastAction), {
        appearance: "list"
    }))));
};


var $dDu9z = parcelRequire("dDu9z");


var $jb4sa = parcelRequire("jb4sa");

const $53e35d7d38738d3f$var$getViewComponent = (appearance)=>{
    switch(appearance){
        case 'grid':
            return 0, $87f8c933d272d979$export$5a87d90ca5d04034;
        case 'list':
            return 0, $089b4dc59c13daf7$export$84d0dd190d551cd1;
        case 'compact-list':
            return 0, $838b83bb70ba05a9$export$f9e5c039a4efefae;
        case 'popup-view':
            return 0, $dDu9z.PopupView;
        case 'end-of-page':
            return 0, $kzTi3.EndOfPageView;
        case 'compact-end-of-page':
            return 0, $kzTi3.EndOfPageView;
    }
};
const $53e35d7d38738d3f$export$832e93955c36efe9 = (wrapperProps)=>{
    const $ = (0, $bDgLe.c)(7);
    let t0;
    if ($[0] !== wrapperProps.appearance) {
        t0 = $53e35d7d38738d3f$var$getViewComponent(wrapperProps.appearance);
        $[0] = wrapperProps.appearance;
        $[1] = t0;
    } else t0 = $[1];
    const View = t0;
    let t1;
    if ($[2] !== View) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(View, null);
        $[2] = View;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t1 || $[5] !== wrapperProps) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jb4sa.PageCardContextProvider), wrapperProps, t1);
        $[4] = t1;
        $[5] = wrapperProps;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
};





'use no memo';
const $18632bf01698551b$var$pageCardConainerStyles = {
    grid: "_2mHwu85zaO _3iDTPbgBM8 _4ouGXIT1Vg _1EqgXlcokz _2iEGP2cGVx",
    list: "_3iDTPbQ4SZ _0aFT5vbt8w _4ouGXIpNyl _3rPG7sdnbC _3qbPiaYbGa _2THw8pYbGa _3UHfcmmhAQ _3aGD4iZpcK _4eyCfvYbGa _2qAqvP8fU6 _2ircOc8fU6 _1EFJVndnbC _27B7RjdnbC _2gOoEYOeNX _0JxSfTdnbC _0SARLudnbC _37CjK68fU6 _4yhhGD8fU6",
    'compact-list': ""
};
const $18632bf01698551b$export$a92f8045b239279b = ({ appearance: appearance, nodes: nodes, analyticsData: analyticsData })=>{
    const [width, setWidth] = (0, $cozmU.useState)(0);
    const onResize = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(setWidth, 200, {
        leading: false
    });
    const pageCardsContextValue = (0, $cozmU.useMemo)(()=>({
            width: width
        }), [
        width
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4xawV.PageCardsContext).Provider, {
        value: pageCardsContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        role: "list",
        className: (0, $hekY6.default)([
            $18632bf01698551b$var$pageCardConainerStyles[appearance]
        ])
    }, nodes.map((node, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $53e35d7d38738d3f$export$832e93955c36efe9), {
            appearance: appearance,
            data: node,
            key: node.key || node.id,
            ranking: i,
            analyticsData: analyticsData
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1LXnB.WidthObserver), {
        setWidth: onResize,
        offscreen: true
    })));
};
module.exports["PageCards"] = $18632bf01698551b$export$a92f8045b239279b;

});

parcelRegister("jYcXA", function(module, exports) {

let $e89dac80e1644989$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e89dac80e1644989$var$load("dZulV"),
    $e89dac80e1644989$var$load("aLbuU"),
    $e89dac80e1644989$var$load("6wr18"),
    $e89dac80e1644989$var$load("6damH"),
    $e89dac80e1644989$var$load("ffEVr"),
    $e89dac80e1644989$var$load("7EorR"),
    $e89dac80e1644989$var$load("cUtrS")
]).then(()=>parcelRequire('bzo9I'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("8VNSW", function(module, exports) {
/* Options.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4yg9g = parcelRequire("4yg9g");


var $hAgam = parcelRequire("hAgam");


var $9DHhW = parcelRequire("9DHhW");


var $9GVkD = parcelRequire("9GVkD");


var $lBLrW = parcelRequire("lBLrW");


var $b3j2Y = parcelRequire("b3j2Y");


var $ktNBJ = parcelRequire("ktNBJ");


var $lXXa4 = parcelRequire("lXXa4");

const $6517be26292f0fb8$var$i18n = (0, $kSwu1.defineMessages)({
    textFilterPlaceholder: {
        id: "home.views.recent.options.placeholder",
        defaultMessage: "Filter by title"
    },
    textFilterDescription: {
        id: "home.views.recent.options.filter.description",
        defaultMessage: "Results will update as you type."
    },
    filteredResultsCount: {
        id: "home.views.recent.filtered-results-announcement",
        defaultMessage: "{count, plural, one {# result} other {# results}} found"
    }
});
const $6517be26292f0fb8$var$optionsContainerStyles = null;
const $6517be26292f0fb8$var$optionsLeftStyles = null;
const $6517be26292f0fb8$export$c019608e5b5bb4cb = ({ appearance: appearance, setAppearance: setAppearance, filterText: filterText, setFilterText: setFilterText, pill: pill, setPill: setPill, pills: pills, loading: loading, queryError: queryError, mutationError: mutationError, pageCardDataLength: pageCardDataLength })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const selectedView = (0, $ktNBJ.useSelectedView)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const onSearchChange = (0, $cozmU.useCallback)((e)=>{
        const text = e.currentTarget.value;
        setFilterText(text);
    }, [
        setFilterText
    ]);
    const onClick = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: `${selectedView}Screen`,
                action: 'clicked',
                actionSubject: 'textField',
                actionSubjectId: `${selectedView}ScreenSearchBar`
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        selectedView
    ]);
    const placeholder = formatMessage($6517be26292f0fb8$var$i18n.textFilterPlaceholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuI7V3 _1DCdHiVa5s"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
        placeholder: placeholder,
        "aria-label": placeholder,
        defaultValue: filterText,
        isCompact: true,
        width: "medium",
        onChange: onSearchChange,
        onClick: onClick,
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
            label: "",
            spacing: "spacious"
        }),
        "aria-describedby": "filterByTitleDescription"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), {
        id: "filterByTitleDescription",
        role: "status"
    }, filterText !== '' ? formatMessage($6517be26292f0fb8$var$i18n.filteredResultsCount, {
        count: pageCardDataLength
    }) : formatMessage($6517be26292f0fb8$var$i18n.textFilterDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lXXa4.Pills), {
        pill: pill,
        setPill: setPill,
        pills: pills
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lBLrW.PageCardAppearanceToggle), {
        appearance: appearance,
        setAppearance: setAppearance,
        disabled: loading,
        source: `${selectedView}Screen`
    }), queryError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: queryError
    }), mutationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: mutationError
    }));
};
module.exports["Options"] = $6517be26292f0fb8$export$c019608e5b5bb4cb;

});

parcelRegister("lBLrW", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $lpNn5 = parcelRequire("lpNn5");





var $3u0dr = parcelRequire("3u0dr");








var $7Mix9 = parcelRequire("7Mix9");

const $fb6e993b302714b6$export$e6090e20fb1e56e9 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const primaryColor = props.primaryColor || "var(--ds-icon, #292A2E)";
    const label = props.label || "";
    let t0;
    if ($[0] !== label || $[1] !== primaryColor || $[2] !== props.testId) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Mix9))), {
            label: label,
            color: primaryColor,
            spacing: "spacious",
            testId: props.testId
        });
        $[0] = label;
        $[1] = primaryColor;
        $[2] = props.testId;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props)=>{
    const primaryColor = props.primaryColor || "var(--ds-icon, #292A2E)";
    const label = props.label || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Mix9))), {
        label: label,
        color: primaryColor,
        spacing: "spacious",
        testId: props.testId
    });
};


const $892d154fe52aa703$export$f0f500e4832f7ca4 = ({ label: label, primaryColor: primaryColor, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fb6e993b302714b6$export$e6090e20fb1e56e9), {
        label: label,
        testId: testId,
        primaryColor: primaryColor
    });
};














var $k0CUL = parcelRequire("k0CUL");

const $0471bf2ec075209c$export$3570ac4c3e881cb1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const primaryColor = props.primaryColor || "var(--ds-icon, #292A2E)";
    const label = props.label || "";
    let t0;
    if ($[0] !== label || $[1] !== primaryColor || $[2] !== props.testId) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k0CUL))), {
            color: primaryColor,
            spacing: "spacious",
            label: label,
            testId: props.testId
        });
        $[0] = label;
        $[1] = primaryColor;
        $[2] = props.testId;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props)=>{
    const primaryColor = props.primaryColor || "var(--ds-icon, #292A2E)";
    const label = props.label || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k0CUL))), {
        color: primaryColor,
        spacing: "spacious",
        label: label,
        testId: props.testId
    });
};


const $f1bed3656a6df92d$export$fa17e9a974485717 = ({ label: label, primaryColor: primaryColor, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0471bf2ec075209c$export$3570ac4c3e881cb1), {
        label: label,
        testId: testId,
        primaryColor: primaryColor
    });
};














var $bQxZI = parcelRequire("bQxZI");

const $0bd5fe9912278910$export$4c9b65bdcf92ad22 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const primaryColor = props.primaryColor || "var(--ds-icon, #292A2E)";
    const label = props.label || "";
    let t0;
    if ($[0] !== label || $[1] !== primaryColor || $[2] !== props.testId) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bQxZI))), {
            label: label,
            color: primaryColor,
            spacing: "spacious",
            testId: props.testId
        });
        $[0] = label;
        $[1] = primaryColor;
        $[2] = props.testId;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props)=>{
    const primaryColor = props.primaryColor || "var(--ds-icon, #292A2E)";
    const label = props.label || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bQxZI))), {
        label: label,
        color: primaryColor,
        spacing: "spacious",
        testId: props.testId
    });
};


const $781dc60d1c0744fb$export$230671d7ba50d3c8 = ({ label: label, primaryColor: primaryColor, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0bd5fe9912278910$export$4c9b65bdcf92ad22), {
        label: label,
        testId: testId,
        primaryColor: primaryColor
    });
};


/* PageCardAppearanceOption.tsx generated by @compiled/babel-plugin v3.0.2 */ 





'use no memo';
const $83cf45b7dcdaab8f$var$inputStyle = null;
const $83cf45b7dcdaab8f$var$baseLabelStyle = null;
const $83cf45b7dcdaab8f$var$hoverAndFocusStyle = null;
const $83cf45b7dcdaab8f$var$selectedHoverAndFocusStyles = null;
const $83cf45b7dcdaab8f$var$disabledStyle = null;
const $83cf45b7dcdaab8f$export$38dfdd608e2cb4f4 = ({ isChecked: isChecked, onClick: onClick, ToggleIcon: ToggleIcon, disabled: disabled = false, label: label })=>{
    const [isFocused, setIsFocused] = (0, $cozmU.useState)(false);
    const toggleFocus = (0, $cozmU.useCallback)(()=>{
        setIsFocused(!isFocused);
    }, [
        isFocused
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("label", {
        className: (0, $hekY6.default)([
            "_0bjKvDKxmn _0GwItXDIqT _37wbyuDIqT _3iDTPbQ4SZ _0wOv4Q7zJH _0hPCNLDIqT",
            disabled && "_0wOv4Qsyl5",
            isChecked && !disabled ? "_3iYkPuujt8 _30638CzXzM _0ux1jMdnbC _1eOmH6mhAQ" : "_1eOmH6mhAQ"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        type: "radio",
        name: "project-type-selection",
        checked: isChecked,
        onClick: onClick,
        onFocus: toggleFocus,
        onBlur: toggleFocus,
        "aria-checked": isChecked,
        "aria-label": label,
        disabled: disabled,
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _1YKVNsdnbC _1pp6NdYbGa _0jFU0VNHnM _39xV02NHnM"
        ])
    }), ToggleIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ToggleIcon, {
        size: "medium",
        primaryColor: !disabled && isChecked ? "var(--ds-text-selected, #1868DB)" : "var(--ds-text-subtlest, #6B6E76)"
    }));
};


const $f25b105f04129604$var$toggleContainerStyles = null;
const $f25b105f04129604$var$i18n = (0, $kSwu1.defineMessages)({
    cardView: {
        id: "page-card.toggle.card-view",
        defaultMessage: "Cards"
    },
    listView: {
        id: "page-card.toggle.list-view",
        defaultMessage: "List"
    },
    compactListView: {
        id: "page-card.toggle.compact-list-view",
        defaultMessage: "Compact list"
    },
    radioGroupLabel: {
        id: "page-card.toggle.radio-group-label",
        defaultMessage: "Appearance"
    }
});
const $f25b105f04129604$export$ff902e0e5a0ce993 = (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { appearance: appearance, setAppearance: setAppearance, disabled: disabled, order: t1, source: source } = t0;
    const order = t1 === undefined ? [
        "grid",
        "list"
    ] : t1;
    const filteredOrder = order.filter($f25b105f04129604$var$_temp);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const intl = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== disabled || $[2] !== setAppearance || $[3] !== source) {
        t2 = (appearance_0)=>{
            if (disabled) return;
            setAppearance(appearance_0);
            const actionSubjectId = appearance_0 === "grid" ? "cards" : "list";
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: source,
                    action: "clicked",
                    actionSubject: "tab",
                    actionSubjectId: actionSubjectId
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = disabled;
        $[2] = setAppearance;
        $[3] = source;
        $[4] = t2;
    } else t2 = $[4];
    const onClick = t2;
    const toggles = {
        grid: {
            id: "grid",
            i18n: $f25b105f04129604$var$i18n.cardView,
            icon: (0, $f1bed3656a6df92d$export$fa17e9a974485717)
        },
        list: {
            id: "list",
            i18n: $f25b105f04129604$var$i18n.listView,
            icon: (0, $781dc60d1c0744fb$export$230671d7ba50d3c8)
        },
        "compact-list": {
            id: "compact-list",
            i18n: $f25b105f04129604$var$i18n.compactListView,
            icon: (0, $892d154fe52aa703$export$f0f500e4832f7ca4)
        },
        "popup-view": null,
        "end-of-page": null,
        "compact-end-of-page": null
    };
    const t3 = "radiogroup";
    let t4;
    if ($[5] !== intl) {
        t4 = intl.formatMessage($f25b105f04129604$var$i18n.radioGroupLabel);
        $[5] = intl;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $hekY6.default)([
            "_2mHwu81Y8M _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _3iDTPbccYA _0aFT5v1qpb _0hPCNLDIqT _0aNu0LYbGa _37wbyuDIqT"
        ]);
        $[7] = t5;
    } else t5 = $[7];
    const t6 = filteredOrder.map((t)=>{
        const toggle = toggles[t];
        const ToggleIcon = toggle?.icon;
        return toggle && ToggleIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            key: toggle.id,
            content: intl.formatMessage(toggle.i18n),
            hideTooltipOnClick: true,
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
            key: toggle.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $83cf45b7dcdaab8f$export$38dfdd608e2cb4f4), {
            onClick: ()=>onClick(toggle.id),
            isChecked: appearance === toggle.id,
            ToggleIcon: ToggleIcon,
            disabled: disabled,
            label: intl.formatMessage(toggle.i18n)
        })));
    });
    let t7;
    if ($[8] !== t4 || $[9] !== t5 || $[10] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", {
            role: t3,
            "aria-label": t4,
            className: t5
        }, t6);
        $[8] = t4;
        $[9] = t5;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    return t7;
};
const $f25b105f04129604$export$dc05e76bf044b54 = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const defaultAppearance = t0 === undefined ? "grid" : t0;
    const [appearance, setAppearance] = (0, $cozmU.useState)(defaultAppearance);
    let t1;
    if ($[0] !== appearance) {
        t1 = {
            appearance: appearance,
            setAppearance: setAppearance
        };
        $[0] = appearance;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
function $f25b105f04129604$var$_temp(view) {
    return view !== "compact-list";
}
module.exports["PageCardAppearanceToggle"] = $f25b105f04129604$export$ff902e0e5a0ce993;

});

parcelRegister("lXXa4", function(module, exports) {
/* Pills.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $9wGTI = parcelRequire("9wGTI");


var $ktNBJ = parcelRequire("ktNBJ");

const $4342bec3f656d280$var$i18n = (0, $kSwu1.defineMessages)({
    filterGroupLabel: {
        id: "home.views.options.filter-group.label",
        defaultMessage: "Filter results"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4342bec3f656d280$var$PillsContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2Zuz6QNHnM _3iDTPbQ4SZ _0hPCNLDIqT _1Znuxb5zaO",
            __cmplp.className
        ])
    });
});
const $4342bec3f656d280$var$PillButton = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2xIroY98eZ _497WNwYbGa _2zndICT6kp _2sNsIgmnOE _4FKVYE2ADO _0bjKvDS5Zs _24h04i2Njc _3iDTPbccYA _0wOv4Q7zJH _20VacPYbGa _1ANEUSLRg7 _1RrJLiBwqQ _2XsHFM2ADO _0jFU0VUofl _37wbyuDIqT _0hPCNLDIqT _4ouGXIpJKa _2sQMlIdnbC _2fqI0WXzJH _0xkEdpjOvk",
            __cmplp.isSelected ? "_0KLXruY9q9" : "_0KLXruDMqu",
            __cmplp.isSelected ? "_1UtDYzjTy9" : "_1UtDYzy7kJ",
            __cmplp.isSelected ? "_1eOmH6sumd" : "_1eOmH6KcZT",
            __cmplp.isSelected ? "_30huDKLylE" : "_30huDKfqb4",
            __cmplp.className
        ])
    });
});
const $4342bec3f656d280$var$finesseStyles = {
    selected: "_3vBAKHrzt2 _2hGPVj98eZ _2i3C1kYbGa _2kH23qT6kp _1wT6Jgrzt2",
    unselected: "_3vBAKH9r67 _0KLXru66of _1eOmH6o126 _3gzVzLN4oS"
};
const $4342bec3f656d280$export$93f0733b9cd7cb26 = ({ pill: pill, setPill: setPill, pills: pills })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const selectedView = (0, $ktNBJ.useSelectedView)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const onClick = (pillButton)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: `${selectedView}Screen`,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: pillButton.name
            }
        }).fire();
        setPill && setPill(pillButton.name);
    };
    return pills ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4342bec3f656d280$var$PillsContainer, {
        role: "group",
        "aria-label": formatMessage($4342bec3f656d280$var$i18n.filterGroupLabel)
    }, pills.map((pillButton)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4342bec3f656d280$var$PillButton // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: (0, $hekY6.default)([
                pillButton.name === pill && (0, $9wGTI.fg)('platform-dst-tokens-finesse') && $4342bec3f656d280$var$finesseStyles.selected,
                pillButton.name !== pill && // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
                (0, $9wGTI.fg)('platform-dst-tokens-finesse') && $4342bec3f656d280$var$finesseStyles.unselected,
                "select-task-view"
            ]),
            key: pillButton.name,
            isSelected: pillButton.name === pill,
            onClick: ()=>onClick(pillButton),
            "aria-pressed": pillButton.name === pill
        }, pillButton.i18n))) : null;
};
module.exports["Pills"] = $4342bec3f656d280$export$93f0733b9cd7cb26;

});

parcelRegister("92U9l", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bQm3c = parcelRequire("bQm3c");

/**
 * @generated SignedSource<<162ee00fd37e9fab42fad4e63f430d66>>
 * @relayHash 05bae897240e208934a7314720c18f00
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 39afc123c06c997743588fe8d7ca244af12fe910448210de00078d85d933617d
const $01a6c0edea318876$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "appearance"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "homePagesDisplayView",
                            "variableName": "appearance"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "userPreferences"
                }
            ],
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "updateUserPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "homePagesDisplayView"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useHomeViewsUserPreferencesHomeViewsUserPreferencesMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useHomeViewsUserPreferencesHomeViewsUserPreferencesMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "05bae897240e208934a7314720c18f00",
            "id": "39afc123c06c997743588fe8d7ca244af12fe910448210de00078d85d933617d",
            "metadata": {},
            "name": "useHomeViewsUserPreferencesHomeViewsUserPreferencesMutation",
            "operationKind": "mutation",
            "text": "mutation useHomeViewsUserPreferencesHomeViewsUserPreferencesMutation($appearance:PagesDisplayPersistenceOption!){updateUserPreferences(userPreferences:{homePagesDisplayView:$appearance}){homePagesDisplayView}}"
        }
    };
}();
$01a6c0edea318876$var$node.hash = "8413f3eedb4fdf231e9546613d4fa7b8";
var $01a6c0edea318876$export$2e2bcd8739ae039 = $01a6c0edea318876$var$node;


/**
 * @generated SignedSource<<6d69f14dfc235e3e4d6de1797779798f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f4d40ef7fe2ee284$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useHomeViewsUserPreferencesFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "homePagesDisplayView"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "UserPreferences"
};
$f4d40ef7fe2ee284$var$node.hash = "22c9279f3bfbbbd633c516d85ea10c25";
var $f4d40ef7fe2ee284$export$2e2bcd8739ae039 = $f4d40ef7fe2ee284$var$node;



var $igBnm = parcelRequire("igBnm");





var $308Wd = parcelRequire("308Wd");


var $jMyy4 = parcelRequire("jMyy4");


var $ij4CE = parcelRequire("ij4CE");





const $1ace401e96fe65a9$var$useHomeViewsUserPreferencesQuery = (0, $igBnm.default);
const $1ace401e96fe65a9$export$d3291c051e5b508d = (defaultPreference = 'CARDS')=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $f4d40ef7fe2ee284$export$2e2bcd8739ae039),
        fragmentSpec: (0, $f4d40ef7fe2ee284$export$2e2bcd8739ae039),
        __callerPackage__: "home"
    });
    const { data: data, loading: loading, error: queryError } = (0, $jMyy4.useQueryInterop)($1ace401e96fe65a9$var$useHomeViewsUserPreferencesQuery, {
        skip: !isLoggedIn,
        __callerPackage__: "home"
    });
    const appearance = data?.userPreferences?.homePagesDisplayView || defaultPreference;
    const [homeViewsUserPreferencesMutation, { error: mutationError }] = (0, $308Wd.useMutationInterop)((0, $01a6c0edea318876$export$2e2bcd8739ae039), {
        __callerPackage__: "home"
    });
    const updateHomeViewsUserPreference = (appearance)=>{
        if (isLoggedIn) {
            homeViewsUserPreferencesMutation({
                variables: {
                    appearance: appearance
                },
                optimisticResponse: {
                    // @ts-ignore __typename does not exist on autogenerated graphql types
                    __typename: 'Mutation',
                    updateUserPreferences: {
                        // @ts-ignore __typename does not exist on autogenerated graphql types
                        __typename: 'UserPreferences',
                        homePagesDisplayView: appearance
                    }
                }
            }).catch(()=>{}); // Ignore the error here since it is handled in useMutation
            // Always write to the cache so the user sees the preference even if there is an error
            // Use writeFragmentInterop instead of writeQuery
            writeFragmentInterop({
                fragmentId: '$ROOT_QUERY.userPreferences',
                data: {
                    homePagesDisplayView: appearance,
                    __typename: 'UserPreferences'
                }
            });
        }
    };
    return {
        loading: loading,
        queryError: queryError,
        mutationError: mutationError,
        appearance: appearance,
        updateHomeViewsUserPreference: updateHomeViewsUserPreference
    };
};
const $1ace401e96fe65a9$export$53a53a6921472be1 = (defaultPreference = 'CARDS')=>{
    const [appearance, setAppearance] = (0, $cozmU.useState)(defaultPreference);
    return {
        loading: false,
        appearance: appearance,
        updateHomeViewsUserPreference: setAppearance
    };
};


const $24342ec75a348aae$var$AppearancePersistenceToToggle = {
    CARDS: 'grid',
    LIST: 'list',
    COMPACT_LIST: 'compact-list',
    // Relay adds "%future added value" to all enums for forward compatibility, but it will never actually be used
    '%future added value': 'grid'
};
const $24342ec75a348aae$var$AppearanceToggleToPersistence = {
    grid: 'CARDS',
    list: 'LIST',
    'compact-list': 'COMPACT_LIST',
    'popup-view': 'CARDS',
    'end-of-page': 'CARDS',
    'compact-end-of-page': 'CARDS'
};
const $24342ec75a348aae$export$b8ae39f344200a7d = (pills, defaultPill)=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const [filterText, setFilterText] = (0, $cozmU.useState)('');
    const [pill, setPill] = (0, $cozmU.useState)(defaultPill);
    /**
	 * The default pill will only change if an override from query params changes.
	 * In this case, we need to update the state in order for the UI to reflect
	 * the new pill.
	 */ (0, $cozmU.useEffect)(()=>{
        // eslint-disable-next-line react-hooks/exhaustive-deps -- oxlint upgrade to 1.9.0
        setPill(defaultPill);
    }, [
        defaultPill
    ]);
    const loggedInUserPreferences = (0, $1ace401e96fe65a9$export$d3291c051e5b508d)();
    const anonymousUserPreferences = (0, $1ace401e96fe65a9$export$53a53a6921472be1)();
    const { loading: loading, queryError: queryError, mutationError: mutationError, appearance: appearance, updateHomeViewsUserPreference: updateHomeViewsUserPreference } = isLoggedIn ? loggedInUserPreferences : anonymousUserPreferences;
    const setAppearance = (appearance)=>{
        updateHomeViewsUserPreference($24342ec75a348aae$var$AppearanceToggleToPersistence[appearance]);
    };
    const optionsData = {
        loading: loading,
        queryError: queryError,
        mutationError: mutationError,
        filterText: filterText,
        setFilterText: setFilterText,
        appearance: $24342ec75a348aae$var$AppearancePersistenceToToggle[appearance],
        setAppearance: setAppearance
    };
    if (pills) {
        optionsData.pill = pill;
        optionsData.pill = pill;
        optionsData.setPill = setPill;
        optionsData.pills = pills;
    }
    return optionsData;
};
module.exports["useOptions"] = $24342ec75a348aae$export$b8ae39f344200a7d;

});

parcelRegister("c2B7a", function(module, exports) {
/* LoadingAndPagination.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $lfoFx = parcelRequire("lfoFx");


var $b3j2Y = parcelRequire("b3j2Y");


var $fLinG = parcelRequire("fLinG");


var $ctLrB = parcelRequire("ctLrB");





var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $9DHhW = parcelRequire("9DHhW");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $I7hWB = parcelRequire("I7hWB");


var $bQm3c = parcelRequire("bQm3c");


var $1NBp8 = parcelRequire("1NBp8");

var $84b9ce8efdf2dab6$exports = {};
$84b9ce8efdf2dab6$exports = new URL("NoResultsImage.ca37f2fe.svg", import.meta.url).toString();


const $2e32c2416bb0a42b$var$NoResultsContainerStyles = (0, $buxP3.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
});
const $2e32c2416bb0a42b$export$ef6006467f04ee41 = ({ message: message, subMessage: subMessage, filterText: filterText, source: source, filter: filter })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const fireTrackEvent = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'shown',
                actionSubject: `${source}NoResults`,
                source: source
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source
    ]);
    const onSearchClick = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: `${source}SearchLink`,
                source: source
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source
    ]);
    (0, $cozmU.useEffect)(()=>{
        fireTrackEvent();
    }, [
        fireTrackEvent
    ]);
    const hasAdvancedSearchContributorSetting = 'WORKED_ON' === filter;
    const hasAdvancedSearchOwnerSetting = 'CREATED' === filter;
    const searchHref = (0, $1NBp8.ADVANCED_SEARCH).toUrl({}, {
        query: {
            text: filterText,
            ...hasAdvancedSearchContributorSetting && userId && {
                contributors: userId
            },
            ...hasAdvancedSearchOwnerSetting && userId && {
                owners: userId
            }
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $2e32c2416bb0a42b$var$NoResultsContainerStyles,
        paddingBlockStart: "space.1000"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($84b9ce8efdf2dab6$exports))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        paddingBlockStart: "space.600",
        paddingBlockEnd: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "small",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), message))), subMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...subMessage,
        values: {
            a: (anchorText)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: searchHref,
                    onClick: onSearchClick
                }, anchorText)
        }
    }));
};


/* Empty.tsx generated by @compiled/babel-plugin v3.0.2 */ 









var $4aRua = parcelRequire("4aRua");


var $cJ0FD = parcelRequire("cJ0FD");

var $82a3a3f8a914d9a8$exports = {};
$82a3a3f8a914d9a8$exports = new URL("EmptyStateImageLight.6df2a248.svg", import.meta.url).toString();


const $10e3f67db57b52fe$var$emptyContainerStyles = null;
const $10e3f67db57b52fe$var$emptyHeaderStyles = null;
const $10e3f67db57b52fe$var$emptyBodyStyles = null;
const $10e3f67db57b52fe$var$callToActionStyles = null;
const $10e3f67db57b52fe$var$emptyStateImage = {
    src: (0, (/*@__PURE__*/$parcel$interopDefault($82a3a3f8a914d9a8$exports)))
};
const $10e3f67db57b52fe$export$1f74963c34e8bfec = ({ header: header, body: body, image: image = $10e3f67db57b52fe$var$emptyStateImage, callToAction: callToAction })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_313842GXk2 _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: image.src,
        srcDark: image.srcDark,
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("h3", {
        className: (0, $hekY6.default)([
            "_313842rIqH"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), header)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_3138425zaO _39xV02KEOu _2fwxA5DIqT"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...body,
        values: {
            strong: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                    as: "strong"
                }, chunks)
        }
    })), callToAction && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_3138425zaO"
        ])
    }, callToAction));



var $edxGF = parcelRequire("edxGF");

const $0efe97bbc4ecdd1c$var$loadingMoreStyles = null;
const $0efe97bbc4ecdd1c$var$loadingOverlayStyles = null;
const $0efe97bbc4ecdd1c$var$overlaySpinnerContainerStyles = null;
const $0efe97bbc4ecdd1c$export$2a05df71362b48c6 = ({ pageCardDataLength: pageCardDataLength, loading: loading, error: error, hasNextPage: hasNextPage, loadMore: loadMore, emptyState: emptyState, noResultsMessage: noResultsMessage, noResultsSubtext: noResultsSubtext, emptyMessageHeader: emptyMessageHeader, emptyMessageBody: emptyMessageBody, emptyMessageImage: emptyMessageImage, emptyMessageCallToAction: emptyMessageCallToAction, filterText: filterText, source: source, filter: filter })=>{
    const shouldShowEmptyState = loading === (0, $ctLrB.LoadingState).done && pageCardDataLength === 0 && !hasNextPage && !error;
    let emptyStateContent = null;
    if (shouldShowEmptyState) {
        if (filterText !== '') emptyStateContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2e32c2416bb0a42b$export$ef6006467f04ee41), {
            message: noResultsMessage,
            subMessage: noResultsSubtext,
            filterText: filterText,
            source: source,
            filter: filter
        });
        else emptyStateContent = emptyState ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $10e3f67db57b52fe$export$1f74963c34e8bfec), {
            header: emptyMessageHeader,
            body: emptyMessageBody,
            image: emptyMessageImage,
            callToAction: emptyMessageCallToAction
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "aria-live": "assertive",
        "aria-atomic": "true"
    }, emptyStateContent, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $edxGF.Error), null)) : null), loading === (0, $ctLrB.LoadingState).initial && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1pp6NdYbGa _1mT5xdWVPG _2IhTondnbC _4ApkO2dnbC _0Bm75GdnbC _3OE6xYdnbC _3iDTPbQ4SZ _3hRCZuDIqT _0hPCNLDIqT _1zccFRDIqT _37wbyuDIqT _1YKVNsXvJ3"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _2IhTongZxp _3OE6xY715P"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "large",
        testId: "view-loading"
    }))), hasNextPage && (filterText !== '' || pageCardDataLength !== 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fLinG.ViewportObserver), {
        onViewportEnter: loadMore
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: {
            position: 'absolute',
            bottom: '0',
            height: '300px'
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_313842Va5s _0jFU0VL04q _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "large",
        testId: "page-loading"
    }))));
};
module.exports["LoadingAndPagination"] = $0efe97bbc4ecdd1c$export$2a05df71362b48c6;

});

parcelRegister("2HiJn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ln0hx = parcelRequire("ln0hx");

var $hjygH = parcelRequire("hjygH");


var $ctLrB = parcelRequire("ctLrB");

const $3cb714216690befb$export$4d0d88e71115d042 = ({ experienceName: experienceName, loading: loading, error: error, attributes: attributes })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
        name: experienceName
    }), loading === (0, $ctLrB.LoadingState).done && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hjygH.ExperienceStop), {
        name: experienceName,
        error: error,
        attributes: attributes
    }));
};
module.exports["ExperienceTracking"] = $3cb714216690befb$export$4d0d88e71115d042;

});

parcelRegister("fROKr", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9KSWX = parcelRequire("9KSWX");


var $AXitC = parcelRequire("AXitC");

const $a2dbea423c2ae9ef$var$i18n = (0, $kSwu1.defineMessages)({
    unpublished: {
        id: "page-card.lozenge.unpublished",
        defaultMessage: "unpublished changes"
    },
    draft: {
        id: "page-card.lozenge.draft",
        defaultMessage: "draft"
    },
    draftUpdated: {
        id: "page-card.lozenge.draft.updated",
        defaultMessage: "Draft"
    }
});
const $a2dbea423c2ae9ef$var$columnSpacingStyles = null;
const $a2dbea423c2ae9ef$export$f72db4ad1e9b3e6d = (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { isInColumn: isInColumn } = t0;
    const { status: status } = (0, $cozmU.useContext)((0, $AXitC.PageCardContext));
    const isValidStatus = status && !!$a2dbea423c2ae9ef$var$i18n[status];
    const message = status === "draft" ? $a2dbea423c2ae9ef$var$i18n.draftUpdated : $a2dbea423c2ae9ef$var$i18n[status];
    let t1;
    if ($[0] !== isInColumn || $[1] !== isValidStatus || $[2] !== message) {
        t1 = isValidStatus ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                isInColumn && "_3138425zaO"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: "neutral"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), message))) : null;
        $[0] = isInColumn;
        $[1] = isValidStatus;
        $[2] = message;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
module.exports["StatusLozenge"] = $a2dbea423c2ae9ef$export$f72db4ad1e9b3e6d;

});

parcelRegister("4xawV", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $b73fd81dd104d571$export$38392c04ead71adc = (0, $cozmU.createContext)({
    width: 0
});
module.exports["PageCardsContext"] = $b73fd81dd104d571$export$38392c04ead71adc;

});

parcelRegister("gETnG", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $5xvJl = parcelRequire("5xvJl");


var $AXitC = parcelRequire("AXitC");


var $4xawV = parcelRequire("4xawV");

const $3fc611f28292b239$var$EXCERPT_LINE_HEIGHT = 14;
const $3fc611f28292b239$var$DEFAULT_NUMBER_OF_LINES = 3;
const $3fc611f28292b239$var$styles = {
    container: "_2O5VijiZR3 _3YEZNOdnbC _1bHrqEIZbP _2sNsIg7NXe _1T2N03wPeg _3138425zaO",
    text: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbgJ9S _4Gn54RiZR3 _1U1ZhbbI28"
};
const $3fc611f28292b239$export$470ad4730dc14be0 = ()=>{
    const $ = (0, $bDgLe.c)(5);
    const { width: width } = (0, $cozmU.useContext)((0, $4xawV.PageCardsContext));
    const { id: id, excerpt: excerpt } = (0, $cozmU.useContext)((0, $AXitC.PageCardContext));
    const DEFAULT_EXCERPT_HEIGHT = $3fc611f28292b239$var$EXCERPT_LINE_HEIGHT * $3fc611f28292b239$var$DEFAULT_NUMBER_OF_LINES;
    const { ref: outerExcerptRef } = (0, $5xvJl.useHeightRef)(DEFAULT_EXCERPT_HEIGHT);
    let t0;
    if ($[0] !== excerpt || $[1] !== id || $[2] !== outerExcerptRef || $[3] !== width) {
        t0 = excerpt ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            key: `${id}-${width}`,
            ref: outerExcerptRef,
            className: (0, $hekY6.default)([
                $3fc611f28292b239$var$styles.container
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $3fc611f28292b239$var$styles.text
            ])
        }, excerpt)) : null;
        $[0] = excerpt;
        $[1] = id;
        $[2] = outerExcerptRef;
        $[3] = width;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
};
module.exports["Excerpt"] = $3fc611f28292b239$export$470ad4730dc14be0;

});

parcelRegister("5xvJl", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $0dca7ed22d181ab5$export$5b067724590b37a4 = (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const defaultHeight = t0 === undefined ? 0 : t0;
    const [height, setHeight] = (0, $cozmU.useState)(defaultHeight);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (node)=>{
            node && setHeight(node.clientHeight);
        };
        $[0] = t1;
    } else t1 = $[0];
    const ref = t1;
    let t2;
    if ($[1] !== height) {
        t2 = {
            height: height,
            ref: ref
        };
        $[1] = height;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
};
module.exports["useHeightRef"] = $0dca7ed22d181ab5$export$5b067724590b37a4;

});


$parcel$global.rlb("1lDWJ")
//# sourceMappingURL=SpaceHoverPageCard.884c0f5a.js.map
